import { createContext, useContext, ReactNode, useState } from "react";

type Params = Record<string, unknown>;

type CommonContextValue = {
  params: Params;
  setParam: (key: string, value: unknown) => void;
  getParam: (key: string) => unknown;
  removeParam: (key: string) => void;
  clearAllParams: () => void;
};

const CommonContext = createContext<CommonContextValue | undefined>(undefined);

export const CommonProvider = ({ children }: { children: ReactNode }) => {
  const [params, setParams] = useState<Params>({});

  const setParam = (key: string, value: unknown) => {
    setParams((prev) => ({ ...prev, [key]: value }));
  };

  const getParam = (key: string) => {
    return params[key];
  };

  const removeParam = (key: string) => {
    setParams((prev) => {
      const newParams = { ...prev };
      delete newParams[key];
      return newParams;
    });
  };

  const clearAllParams = () => {
    setParams({});
  };

  return (
    <CommonContext.Provider value={{ params, setParam, getParam, removeParam, clearAllParams }}>
      {children}
    </CommonContext.Provider>
  );
};

export const useCommon = () => {
  const context = useContext(CommonContext);

  if (context === undefined) {
    throw new Error("useCommon must be used within a CommonProvider");
  }

  return context;
};
